import React, { useContext, useMemo } from "react";
import Statics from "../../../Statics";
import _ from "underscore";
import {
    endVote,
    getVotePaperContent,
    StuVoteItem,
    VoteContent
} from "service/vote";
import style from "./index.module.scss";
import { Button, Icon, message } from "antd";
import CountDown from "components/CourseComponents/CountDown";
import SettingModal from "components/CourseComponents/Vote/SettingModal";
import useModalHandler from "utils/useModalHandler";
import usePromiseCallback from "utils/usePromiseCallback";
import { CourseContext } from "../../../../../Store";
import { useHistory } from "react-router-dom";
import { errorMessage } from "../../../../../../../service/service";

interface HeaderProps {
    filterStatus: string;
    onFilterStatusChange: (text: string) => void;
    data: VoteContent;
    stuList: StuVoteItem[];
    onChange: () => void;
    onCountDown: () => void;
}

export default function Header({
    filterStatus,
    onFilterStatusChange,
    data,
    stuList,
    onChange,
    onCountDown
}: HeaderProps) {
    const { course, basename } = useContext(CourseContext);
    const modal = useModalHandler();
    const history = useHistory();

    // 统计数据
    const statics = useMemo(() => {
        return _.reduce(
            stuList,
            (memo, item) => ({
                courseStuCount: memo.courseStuCount + 1,
                voteStuCount:
                    memo.voteStuCount + (item.voteStatus === "1" ? 1 : 0),
                notVoteStuCount:
                    memo.notVoteStuCount + (item.voteStatus === "0" ? 1 : 0)
            }),
            { courseStuCount: 0, voteStuCount: 0, notVoteStuCount: 0 }
        );
    }, [stuList]);

    const handleEndVote = usePromiseCallback(async function (
        showError: boolean = true
    ) {
        if (!data) return;

        try {
            const detail = await getVotePaperContent(data.id);
            if (detail.validityTime === data.validityTime)
                await endVote(data.id);
        } catch (e) {
            // 自动结束如果报错不进行提示
            if (showError) message.error(errorMessage(e));
        } finally {
            onChange();
        }
    });

    function onVoteOk() {
        modal.close();
        onChange();
    }

    function gotoDetail(voteId: number) {
        history.replace(`${basename}/vote/${voteId}`);
    }

    return (
        <div className={style.root}>
            <div className={style.left}>
                <Statics
                    current={filterStatus}
                    onChange={onFilterStatusChange}
                    {...statics}
                />
            </div>

            <div className={style.right}>
                <div className={style.rightTop}>
                    <CountDown
                        className={style.time}
                        startTime={data.startTime}
                        validityTime={data.validityTime}
                        onEnd={() => handleEndVote(false)}
                        onCountDown={onCountDown}
                    />

                    <button className={style.settingBtn} onClick={modal.open}>
                        <Icon type="setting" />
                    </button>
                </div>

                <Button
                    type="primary"
                    ghost
                    className={style.button}
                    onClick={handleEndVote}>
                    <Icon type="poweroff" /> 结束投票
                </Button>
            </div>

            <SettingModal
                id={data?.id}
                visible={modal.visible}
                onCancel={modal.close}
                onOk={onVoteOk}
                onShowVote={gotoDetail}
                weekTimeId={course.weekTimeId}
            />
        </div>
    );
}
